import Alert from '@mui/material/Alert';
import { Link } from 'react-router';
import { useAppointmentProposalOptionModifiers } from '../../../data-access/appointmentProposalOptionModifiers';
import { useAppointmentProposalOptionProducts } from '../../../data-access/appointmentProposalOptionProducts';
import { useAppointmentProposalOptions } from '../../../data-access/appointmentProposalOptions';
import { useAppointmentProposals } from '../../../data-access/appointmentProposals';
import ROUTE_PATHS from '../../../routes/paths';

const SyncProposalOptionsButton: React.FC = () => {
  const { options } = useAppointmentProposalOptions();
  const { proposalProducts } = useAppointmentProposalOptionProducts();
  const { proposalModifiers } = useAppointmentProposalOptionModifiers();
  const { currentProposal } = useAppointmentProposals();

  const activeOptionIds = new Set(
    options.map((option) => option.appointmentProposalOptionId)
  );

  const filteredItems = [...proposalProducts, ...proposalModifiers]
    .filter((product) =>
      activeOptionIds.has(product.appointmentProposalOptionId)
    )
    .some((product) => !!product.errorDetail);

  const hasError =
    !!currentProposal &&
    (options.some((option) => !!option.errorDetail) || filteredItems);

  return hasError ? (
    <Link
      to={ROUTE_PATHS.APPOINTMENT_PATH({
        appointmentId: currentProposal.appointmentId,
        appointmentProposalId: currentProposal.appointmentProposalId,
        path: 'sync-status',
      })}
    >
      <Alert
        severity="error"
        variant="outlined"
        sx={{
          textDecoration: 'none',
          textDecorationLine: 'none',
        }}
      >
        Estimate sync errors
      </Alert>
    </Link>
  ) : null;
};

export default SyncProposalOptionsButton;
